import { render, staticRenderFns } from "./commerce.vue?vue&type=template&id=6313dfd2&scoped=true"
import script from "./commerce.vue?vue&type=script&lang=js"
export * from "./commerce.vue?vue&type=script&lang=js"
import style0 from "./commerce.vue?vue&type=style&index=0&id=6313dfd2&prod&lang=scss&scoped=true"
import style1 from "./commerce.vue?vue&type=style&index=1&id=6313dfd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6313dfd2",
  null
  
)

export default component.exports